import $ from 'jquery';
import 'minicart/dist/minicart';

class CartLoader {
	constructor(els) {
		this.$cart = $(els.element);

		paypal.minicart.render();

		if (window.location.hash === '#reset') {
			paypal.minicart.reset();
		}

		this.events();
	}

	events() {
		const that = this;

		paypal.minicart.cart.on('add', function() {
			that.updateCart();
		});

		paypal.minicart.cart.on('remove', function() {
			that.updateCart();
		});

		paypal.minicart.cart.on('change', function() {
			that.updateCart();
		});

		$('#PPMiniCart .minicart-quantity').on('keyup', function() {
			that.updateCart();
		});
		
		this.updateCart();

		this.$cart.on('click', '.show', function(e) {
			e.preventDefault();
			e.stopPropagation();

			paypal.minicart.view.show();
		});

		$('body').on('click', '.cart-add', function(e) {
			e.preventDefault();
			e.stopPropagation();

			var $this = $(this),
				gross = parseFloat($this.siblings('.price').text()),
				item = $this.closest('.shop-prices-list').attr('data-item')
					+ ' - ' + $this.closest('.shop-prices-section').find('.shop-prices-title').text()
					+ ' - ' + $this.siblings('.description').text();

			paypal.minicart.cart.add({
				business: 'Orders@thls.org',
				item_name: item,
				amount: gross,
				currency_code: "GBP",
				return: "https://www.trinityhouse.co.uk/shop/thank-you#reset"
			});
		});
	}

	updateCart() {
		var total = paypal.minicart.cart.total().toFixed(2);

		this.$cart.find('.total').text(total);
	}
}

export default {
	init (els) {
		if (!(els.element).length) {
			return;
		}

		new CartLoader(els);
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/cartLoader.js